import React, { Suspense } from "react";
import { useRoutes } from "hookrouter";
import { ThemeProvider } from "styled-components";

import Routes from "./Router";
import THEME from "./res/theme";

const App = () => {
    const routeResult = useRoutes(Routes);
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <ThemedApp>{routeResult}</ThemedApp>
        </Suspense>
    );
};

const ThemedApp = ({ children }) => {
    const theme = THEME.LIGHT;
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default App;
